<template>
  <div>
    <div class="page-title">Edit Custom Component</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Custom Component"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.custom-components.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}”` : `Edit Custom Component`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.CustomComponent.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.CustomComponent.update(this.form);
      this.$allertWindow("Success");
      //this.$router.push("/dev-tools/custom-components");
    },
  },
};
</script>

<style></style>
